export default "__VITE_ASSET__uS952bv5__"